var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',{attrs:{"name":_vm.name,"value":_vm.obj.text,"placeholder":_vm.placeholder,"substitution-tags":_vm.substitutionTags},on:{"input":_vm.updateContents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }